import { Button, Checkbox, Drawer, Input, Radio, Select } from 'antd';
import { useState } from 'react';
import {
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  UpOutlined,
} from '@ant-design/icons';
import { useUnit } from 'effector-react';
import style from './CenterHomeFilters.module.css';
import ButtonsSelect from './ButtonsSelect.jsx';
import {
  $centerHomeFilters,
  $chPoints,
  applyFiltersEv,
  changeCenterHomeFiltersEv,
  resetCenterHomeFiltersEv,
} from '../../models/centerHomeModel/index.js';
import useWindowSize from '../../hooks/useWindowSize.js';

const cities_option = [
  {
    label: 'Астана',
    value: 'Астана',
  },
  {
    label: 'Алматы',
    value: 'Алматы',
  },
  {
    label: 'Караганда',
    value: 'Караганда',
  },
];

const renovation_options = [
  {
    label: 'Черновая',
    value: 'rough',
  },
  {
    label: 'Чистовая',
    value: 'finishing',
  },
  {
    label: 'Евроремонт',
    value: 'renovated',
  },
  {
    label: 'Косметический',
    value: 'cosmetic',
  },
  {
    label: 'Дизайнерский',
    value: 'designer',
  },
];

const rooms_options = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4+',
    value: '4+',
  },
];

const type_options = [
  {
    label: 'Кирпичный',
    value: 'brick',
  },
  {
    label: 'Панельный',
    value: 'panel',
  },
  {
    label: 'Монолитный',
    value: 'monolith',
  },
];

function CenterHomeFilters() {
  const [width, height] = useWindowSize();
  const chPoints = useUnit($chPoints);
  const centerHomeFilters = useUnit($centerHomeFilters);
  const changeCenterHomeFilters = useUnit(changeCenterHomeFiltersEv);
  const resetCenterHomeFilters = useUnit(resetCenterHomeFiltersEv);
  const applyFilters = useUnit(applyFiltersEv);

  if (width < 500) {
    return (
      <MobileFilters
        chPoints={chPoints}
        centerHomeFilters={centerHomeFilters}
        changeCenterHomeFilters={changeCenterHomeFilters}
        resetCenterHomeFilters={resetCenterHomeFilters}
        applyFilters={applyFilters}
      />
    );
  }

  return (
    <>
      <PCFilters
        chPoints={chPoints}
        centerHomeFilters={centerHomeFilters}
        changeCenterHomeFilters={changeCenterHomeFilters}
        resetCenterHomeFilters={resetCenterHomeFilters}
        applyFilters={applyFilters}
      />
      <div className={style.amount_title}>
        Найдено {chPoints.length} квартир
      </div>
    </>
  );
}

function PCFilters(props) {
  const {
    chPoints,
    centerHomeFilters,
    changeCenterHomeFilters,
    resetCenterHomeFilters,
    applyFilters,
  } = props;

  const [collapsed, setCollapsed] = useState(true);
  const residential_complex_options = Array.from(
    new Set(
      chPoints.map((item) => {
        return item.properties.residential_complex;
      })
    )
  )
    .filter((item) => item)
    .map((item) => {
      return {
        label: item,
        value: item,
      };
    });

  return (
    <div className={style.filters_wrapper}>
      <div>
        <div className={style.filters_row}>
          <Select
            options={[{ label: 'Купить', value: 'buy' }]}
            value="buy"
            disabled
            className={style.filter_select}
            variant="borderless"
          />
          <Select
            options={cities_option}
            className={style.filter_select}
            variant="borderless"
            placeholder="Город"
            value={centerHomeFilters.city}
            onChange={(value) => {
              changeCenterHomeFilters({
                field: 'city',
                value,
              });
            }}
          />
          <Select
            options={residential_complex_options}
            maxTagCount="responsive"
            className={style.filter_select}
            style={{ minWidth: 170 }}
            variant="borderless"
            placeholder="Жилой комплекс"
            mode="multiple"
            allowClear
            value={centerHomeFilters.residential_complex}
            onChange={(value) => {
              changeCenterHomeFilters({
                field: 'residential_complex',
                value,
              });
            }}
          />
          <Checkbox
            className={style.filter_checkbox}
            checked={centerHomeFilters.from_owner}
            onChange={(e) =>
              changeCenterHomeFilters({
                field: 'from_owner',
                value: e.target.checked,
              })
            }
          >
            От хозяина недвижимости
          </Checkbox>
          <Checkbox
            className={style.filter_checkbox}
            checked={centerHomeFilters.mortgage}
            onChange={(e) =>
              changeCenterHomeFilters({
                field: 'mortgage',
                value: e.target.checked,
              })
            }
          >
            Подходит под ипотеку
          </Checkbox>
          <Checkbox
            className={style.filter_checkbox}
            checked={centerHomeFilters.tour_3d}
            onChange={(e) =>
              changeCenterHomeFilters({
                field: 'tour_3d',
                value: e.target.checked,
              })
            }
          >
            С 3D туром
          </Checkbox>
        </div>
        <div className={style.divider} />
      </div>
      <div className={style.filters_grid}>
        <div>
          <div className={style.filter_label}>Комнатность</div>
          <ButtonsSelect
            options={rooms_options}
            value={centerHomeFilters.rooms}
            onChange={changeCenterHomeFilters}
            field="rooms"
          />
        </div>
        <div>
          <div className={style.filter_label}>Цена</div>
          <div className={style.input_range}>
            <Input
              placeholder="от"
              className={style.filter_input}
              type="number"
              value={centerHomeFilters.cost_from}
              onChange={(e) =>
                changeCenterHomeFilters({
                  field: 'cost_from',
                  value: e.target.value,
                })
              }
              suffix="тг"
            />
            <Input
              placeholder="до"
              className={style.filter_input}
              type="number"
              value={centerHomeFilters.cost_to}
              onChange={(e) =>
                changeCenterHomeFilters({
                  field: 'cost_to',
                  value: e.target.value,
                })
              }
              suffix="тг"
            />
          </div>
        </div>
        <div>
          <div className={style.filter_label}>Уровень ремонта</div>
          <Select
            options={renovation_options}
            allowClear
            style={{ width: '100%' }}
            mode="multiple"
            maxTagCount="responsive"
            className={style.filter_select}
            placeholder="Выберите"
            value={centerHomeFilters.renovation_level}
            onChange={(value) =>
              changeCenterHomeFilters({ field: 'renovation_level', value })
            }
          />
        </div>
      </div>
      {!collapsed ? (
        <div
          className={style.filters_grid}
          style={{ alignItems: 'flex-start' }}
        >
          <div>
            <div className={style.filter_label}>Тип дома</div>
            <ButtonsSelect
              options={type_options}
              value={centerHomeFilters.house_type}
              field="house_type"
              onChange={changeCenterHomeFilters}
            />
          </div>
          <div>
            <div className={style.filter_label}>Площадь</div>
            <div className={style.input_range}>
              <Input
                placeholder="от"
                className={style.filter_input}
                suffix="м²"
                type="number"
                value={centerHomeFilters.square_from}
                onChange={(e) =>
                  changeCenterHomeFilters({
                    field: 'square_from',
                    value: e.target.value,
                  })
                }
              />
              <Input
                placeholder="до"
                className={style.filter_input}
                suffix="м²"
                type="number"
                value={centerHomeFilters.square_to}
                onChange={(e) =>
                  changeCenterHomeFilters({
                    field: 'square_to',
                    value: e.target.value,
                  })
                }
              />
            </div>
            <Checkbox
              className={style.filter_checkbox}
              style={{ marginTop: 22 }}
              checked={centerHomeFilters.first_floor}
              onClick={(e) =>
                changeCenterHomeFilters({
                  field: 'first_floor',
                  value: e.target.checked,
                })
              }
            >
              не первый этаж
            </Checkbox>
          </div>
          <div>
            <div className={style.filter_label}>Год постройки</div>
            <div className={style.input_range}>
              <Input
                placeholder="от"
                className={style.filter_input}
                suffix="г"
                type="number"
                value={centerHomeFilters.year_from}
                onChange={(e) =>
                  changeCenterHomeFilters({
                    field: 'year_from',
                    value: e.target.value,
                  })
                }
              />
              <Input
                placeholder="до"
                className={style.filter_input}
                suffix="г"
                type="number"
                value={centerHomeFilters.year_to}
                onChange={(e) =>
                  changeCenterHomeFilters({
                    field: 'year_to',
                    value: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      <div
        className={style.filters_row}
        style={{ justifyContent: 'space-between', marginTop: 8 }}
      >
        <Button
          onClick={() => setCollapsed(!collapsed)}
          className={style.hollow}
          icon={collapsed ? <DownOutlined /> : <UpOutlined />}
          iconPosition="end"
        >
          {collapsed ? 'Показать еще' : 'Свернуть'}
        </Button>
        <Button
          type="primary"
          onClick={applyFilters}
          className={style.filter_button}
        >
          Показать результаты
        </Button>
        <Button className={style.hollow} onClick={resetCenterHomeFilters}>
          Очистить фильтр
        </Button>
      </div>
    </div>
  );
}

function MobileFilters(props) {
  const [open, setOpen] = useState(false);
  const [width, height] = useWindowSize();
  const {
    chPoints,
    centerHomeFilters,
    changeCenterHomeFilters,
    resetCenterHomeFilters,
    applyFilters,
  } = props;

  const onApply = () => {
    applyFilters();
    setOpen(false);
  };

  const residential_complex_options = Array.from(
    new Set(
      chPoints.map((item) => {
        return item.properties.residential_complex;
      })
    )
  )
    .filter((item) => item)
    .map((item) => {
      return {
        label: item,
        value: item,
      };
    });

  return (
    <>
      <div
        onClick={() => setOpen(!open)}
        className={style.mobile_filter_button}
      >
        Фильтр
      </div>
      <Drawer
        open={open}
        closable={false}
        width={width}
        styles={{ body: { padding: 0, background: '#f1f5f9' } }}
        push={{ distance: 0 }}
      >
        <div className={style.mobile_filter_title_wrapper}>
          <LeftOutlined onClick={() => setOpen(false)} />
          <div className={style.mobile_filter_title}>Фильтр</div>
          <div
            className={style.mobile_clear_filter}
            onClick={resetCenterHomeFilters}
          >
            Сбросить
          </div>
        </div>
        <div className={style.mobile_filter_wrapper}>
          <div className={style.mobile_filter_block}>
            <Select
              variant="borderless"
              options={cities_option}
              className={style.filter_select}
              placeholder="Город"
              value={centerHomeFilters.city}
              onChange={(value) => {
                changeCenterHomeFilters({
                  field: 'city',
                  value,
                });
              }}
            />
            <Select
              variant="borderless"
              options={residential_complex_options}
              maxTagCount="responsive"
              className={style.filter_select}
              style={{ minWidth: 170 }}
              placeholder="Жилой комплекс"
              mode="multiple"
              allowClear
              value={centerHomeFilters.residential_complex}
              onChange={(value) => {
                changeCenterHomeFilters({
                  field: 'residential_complex',
                  value,
                });
              }}
            />
            <DrawerRangeFilter
              title="Цена"
              measure="тг"
              field="cost"
              changeCenterHomeFilters={changeCenterHomeFilters}
            />
            <Checkbox
              className={style.filter_checkbox}
              checked={centerHomeFilters.mortgage}
              onChange={(e) =>
                changeCenterHomeFilters({
                  field: 'mortgage',
                  value: e.target.checked,
                })
              }
            >
              Ипотека
            </Checkbox>
            <Checkbox
              className={style.filter_checkbox}
              checked={centerHomeFilters.from_owner}
              onChange={(e) =>
                changeCenterHomeFilters({
                  field: 'from_owner',
                  value: e.target.checked,
                })
              }
            >
              От хозяина недвижимости
            </Checkbox>
          </div>
          <div className={style.mobile_filter_block}>
            <div>
              <div className={style.filter_label}>Комнатность</div>
              <ButtonsSelect
                options={rooms_options}
                value={centerHomeFilters.rooms}
                onChange={changeCenterHomeFilters}
                field="rooms"
              />
            </div>
            <div>
              <div className={style.filter_label}>Уровень ремонта</div>
              <ButtonsSelect
                options={renovation_options}
                value={centerHomeFilters.rooms}
                onChange={changeCenterHomeFilters}
                field="rooms"
              />
            </div>
            <DrawerRangeFilter
              title="Площадь"
              measure="м²"
              field="square"
              changeCenterHomeFilters={changeCenterHomeFilters}
            />
            <div>
              <div className={style.filter_label}>Тип дома</div>
              <ButtonsSelect
                options={type_options}
                value={centerHomeFilters.house_type}
                field="house_type"
                onChange={changeCenterHomeFilters}
              />
            </div>
            <DrawerRangeFilter
              title="Год постройки"
              measure="г"
              field="year"
              changeCenterHomeFilters={changeCenterHomeFilters}
            />
          </div>
          <Button
            type="primary"
            onClick={onApply}
            className={style.filter_button}
          >
            Показать результаты
          </Button>
        </div>
      </Drawer>
    </>
  );
}

function DrawerRangeFilter(props) {
  const { title, measure, field, changeCenterHomeFilters } = props;
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const onSubmit = () => {
    changeCenterHomeFilters({
      field: `${field}_from`,
      value: from,
    });
    changeCenterHomeFilters({
      field: `${field}_to`,
      value: to,
    });
    setOpen(false);
  };

  const onClear = () => {
    setFrom('');
    setTo('');
  };

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        className={style.mobile_range_drawer_trigger}
      >
        {title}
        <DownOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />
      </div>
      <Drawer
        placement="bottom"
        open={open}
        closable={false}
        maskClosable
        onClose={() => setOpen(false)}
      >
        <div className={style.mobile_range_drawer_wrapper}>
          <div className={style.mobile_range_drawer_title}>{title}</div>
          <div>
            <div className={style.mobile_range_drawer_label}>От</div>
            <Input
              placeholder="От"
              className={style.filter_input}
              style={{ width: '100%' }}
              type="number"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              suffix={measure}
            />
          </div>
          <div>
            <div className={style.mobile_range_drawer_label}>До</div>
            <Input
              placeholder="До"
              className={style.filter_input}
              style={{ width: '100%' }}
              type="number"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              suffix={measure}
            />
          </div>
          <div className={style.mobile_range_drawer_buttons}>
            <Button
              type="primary"
              onClick={onSubmit}
              className={style.mobile_range_drawer_button}
            >
              Применить
            </Button>
            <Button
              onClick={onClear}
              style={{ border: 'unset', boxShadow: 'unset', color: '#27ae60' }}
              className={style.mobile_range_drawer_button}
            >
              Сбросить
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default CenterHomeFilters;
